var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAccessToPage)?_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"10"}},[_c('InventoryTable')],1)],1)],1):_c('NoAccessMessage')}
var staticRenderFns = []

export { render, staticRenderFns }